import { Injectable, EventEmitter } from '@angular/core';

import { BaseTypeahead } from './base-typeahead';
import { BaseEntity } from '../../../models';

import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';

/** Service para trabalhar com os components de typeahead */
@Injectable({
    providedIn: 'root'
})
export class BaseTypeaheadService {

    /** Ao digitar no input do typeahead */
    onKeyup<T extends BaseEntity>(typeaheadComponent: BaseTypeahead<T> , event: KeyboardEvent) {
        const ignoresKeys: string[] = ['Tab', 'Enter', 'Shift', 'Control', 'Alt', 'Pause', 'CapsLock', 'Escape', ' ', 'PageUp', 'PageDown', 'End', 'Home', 'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Insert', 'Meta',
                                         'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12', 'NumLock', 'ScrollLock'];
        if (ignoresKeys.includes(event.key)) {
            return;
        }
        typeaheadComponent.entity = null;
        typeaheadComponent.propagateChange(typeaheadComponent.entity);
        typeaheadComponent.typeaheadChange.emit(typeaheadComponent.entity);
    }

    /** Ao sair do input do typeahead */
    onBlur<T extends BaseEntity>(typeaheadComponent: BaseTypeahead<T>) {
        if (!typeaheadComponent.entity || typeaheadComponent.entity === null) {
            typeaheadComponent.typeaheadSelected = null;
            typeaheadComponent.inputTypeahead.nativeElement.value = '';
            typeaheadComponent.typeaheadNoResults = false;
        }
    }

    /** Ao selecionar a entitade no typeahead */
    onSelectEntity<T extends BaseEntity>(typeaheadComponent: BaseTypeahead<T>, tm: TypeaheadMatch) {
        const entity: T = tm.item as T;
        if (entity) {
            typeaheadComponent.entity = entity;
        } else {
            typeaheadComponent.entity = null;
        }
        typeaheadComponent.propagateChange(typeaheadComponent.entity);
        typeaheadComponent.typeaheadChange.emit(typeaheadComponent.entity);
    }

    /** Limpa o typeahead e o model */
    clear<T extends BaseEntity>(typeaheadComponent: BaseTypeahead<T>) {
        typeaheadComponent.entity = null;
        typeaheadComponent.typeaheadSelected = null;
        typeaheadComponent.inputTypeahead.nativeElement.value = '';
        typeaheadComponent.typeaheadNoResults = false;
        jQuery(typeaheadComponent.inputTypeahead.nativeElement).focus();

        typeaheadComponent.propagateChange(typeaheadComponent.entity);
        typeaheadComponent.typeaheadChange.emit(typeaheadComponent.entity);
    }

     /** Quando recebe um objeto da entidade de "fora" do component */
    writeValue<T extends BaseEntity>(typeaheadComponent: BaseTypeahead<T>, value: T, typeaheadValue: string = null) {
        if (value) {
            typeaheadComponent.entity = value;
            typeaheadComponent.typeaheadSelected = typeaheadValue;
            typeaheadComponent.typeaheadToken = typeaheadValue;
        } else {
            typeaheadComponent.entity = null;
            typeaheadComponent.typeaheadSelected = null;
            typeaheadComponent.inputTypeahead.nativeElement.value = '';
        }
    }
}
